import { useAuth } from "@clerk/clerk-react";
import { createClient, SupabaseClient } from "@supabase/supabase-js";
import { useCallback } from "react";
import type { Database } from "@/integrations/supabase/types";
import { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY } from "@/lib/supabaseClient";

export const useSupabaseClient = () => {
  const { getToken } = useAuth();

  const getSupabaseClient = useCallback(async () => {
    const jwt = await getToken({ template: "supabase" });
    if (jwt) {
      return createClient<Database>(
        SUPABASE_URL,
        SUPABASE_PUBLISHABLE_KEY,
        {
          global: {
            headers: {
              Authorization: `Bearer ${jwt}`,
            },
          },
        }
      );
    }
    return null;
  }, [getToken]);

  return getSupabaseClient;
};
